import React from 'react'
import cn from 'classnames'
import { AddressSearchSelect } from '@components/AddressSearchSelect'
import { AddressSearchSelectFieldProps } from './interface'

export function AddressSearchSelectField({
  name,
  addressKey,
  label,
  labelClassName,
  placeholder,
  touched,
  error,
  disabled,
  value,
  handleChange,
}: AddressSearchSelectFieldProps) {
  return (
    <div className='relative select-none' id={name}>
      {label && (
        <div
          className={cn(
            'text-[12px] text-secondary-1 font-light mb-[4px]',
            labelClassName
          )}
        >
          {label}
        </div>
      )}
      <AddressSearchSelect
        name={name}
        className={cn({ 'border-red': touched && error })}
        addressKey={addressKey}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onChange={handleChange}
      />
    </div>
  )
}
